import { MeshStandardMaterial, BoxGeometry, Mesh } from 'three';
import { lineDiameter, lineSegmentLength } from '@/Constants/3dConfig';

const lineMaterial = new MeshStandardMaterial({ color: 0x393349 });
const lineBlackMaterial = new MeshStandardMaterial({ color: 0x000000 });

const geometry = new BoxGeometry(1, 1, 1, 6);

export function getLineMesh(black = false) {
    const line = new Mesh(geometry, black ? lineBlackMaterial : lineMaterial);
    line.rotation.x = Math.PI / 2;
    line.scale.set(lineDiameter / 2, lineSegmentLength, lineDiameter / 2);
    return line;
}
